<template>
  <section>
    <div class="pageHeaderDocumentation">
      <h1>{{ $t('api.documentation.header.title') }}</h1>
      <div class="pageHeaderDocumentationSubtitle mt-3">{{ $t('api.documentation.header.subtitle.001') }}</div>
      <div class="pageHeaderDocumentationSubtitle">{{ $t('api.documentation.header.subtitle.002') }}</div>
    </div>
    <CRow>
      <CCol md="3">
        <div class="leftOptionDocumentation">
          <ul class="leftOptionList">
            <li>
              <div class="listTitle">{{ $t('api.documentation.sidemenu.001.title') }}</div>
              <ul class="listItems">
                <!-- <li>{{ $t('api.documentation.sidemenu.001.item.001') }}</li> -->
                <li :class="{ selectedItem: activeSection == pageSections.APIKey }" @click="callScrollClick(pageSections.APIKey)">
                  {{ $t('api.documentation.sidemenu.001.item.002') }}
                </li>
                <li :class="{ selectedItem: activeSection == pageSections.TransactionalSMS }" @click="callScrollClick(pageSections.TransactionalSMS)">
                  {{ $t('api.documentation.sidemenu.001.item.005.SendSMS') }}
                </li>
                <li
                  :class="{ selectedItem: activeSection == pageSections.TransactionalEmail }"
                  @click="callScrollClick(pageSections.TransactionalEmail)"
                >
                  {{ $t('api.documentation.sidemenu.001.item.006.SendEmail') }}
                </li>
              </ul>
            </li>

            <li>
              <div class="listTitle" @click="$router.push({ name: 'questions', params: { contentName: 'faq-api' } })" style="cursor: pointer">
                {{ $t('api.documentation.sidemenu.003.title') }}
              </div>
              <ul class="listItems"></ul>
            </li>
            <!-- <li>
              <div class="listTitle">{{ $t('api.documentation.sidemenu.004.title') }}</div>
              <ul class="listItems"></ul>
            </li> -->
            <li>
              <div class="listTitle" @click="$router.push({ name: 'contactFaq' })" style="cursor: pointer">
                {{ $t('api.documentation.sidemenu.007.title.support') }}
              </div>
              <ul class="listItems"></ul>
            </li>
          </ul>
        </div>
      </CCol>
      <CCol md="8" class="mt-5">
        <DocumentationsContent ref="docContentRef" @sectionChange="(section) => handleSectionChange(section)" />
      </CCol>
    </CRow>
  </section>
</template>

<script>
import DocumentationsContent from './DocumentationsContent.vue'
import { pageSections } from './constants'

export default {
  name: 'DocumentationWrapper',
  components: {
    DocumentationsContent,
  },
  props: {
    title: {
      type: String,
      default: () => ``,
    },
    methodName: {
      type: String,
      default: () => `GET`,
    },
    endpoint: {
      type: String,
      default: () => `http://api.multichannel.sendit.pt/v1.0/sms/send`,
    },
    request: {
      type: String,
      default: () => `{
        organizationId: "04eda20a-e05a-4a05-8b4c-696a9f2af6ac",
        messages: [{
          text: "text",
          to: "351911111111",
          from: "from",
          expirationDateTime: "2022-10-10 09:00"
        }]
      }`,
    },
    response: {
      type: String,
      default: () => `{
        error: {
        code: "code",
        description: "description"
        },
        messages: [
        {
          status: "SUCCESS",
          error: {
          code: "code",
          param: "param",
          description: "description"
          },
          messageId: "04eda20a-e05a-4a05-8b4c-696a9f2af6ac",
          segmentCount: 1
          encoding: "GSM-7bit",
          cost: {
            amount: 1,
            countryCode: "PT"
          }
        }
        ]
      }`,
    },
  },
  data() {
    return {
      pageSections: pageSections,
      codeHtmlTable: `<html>
                      <head></head>
                      <body>
                        <p>Hello, </p>
                        This is my first transacional email sent from Sendit.
                        </p>
                      </body>
                    </html>`,

      paramsRequestSMS: `{
        organizationId: "04eda20a-e05a-4a05-8b4c-696a9f2af6ac",
        messages: [{
          text: "text",
          to: "351911111111",
          from: "from",
          expirationDateTime: "2022-10-10 09:00"
        }]
      }`,

      responseRequestSMS: `{
        organizationId: "04eda20a-e05a-4a05-8b4c-696a9f2af6ac",
        messages: [{
          text: "text",
          to: "351911111111",
          from: "from",
          expirationDateTime: "2022-10-10 09:00"
        }]
      }`,

      paramsRequestEmail: `{
  organizationId: "04eda20a-e05a-4a05-8b4c-696a9f2af6ac",
  messages: [{
    to: "pcristina@sendit.pt",
    from: "pcristina@sendit.pt",
    displayName: "displayName",
    subject: "subject",
    expirationDateTime: "2022-10-10 09:00",
    textContent: "text",
    htmlContent: "htmlContent"
  }]
}`,

      responseRequestEmail: `{
  error: {
	code: "code",
	description: "description"
  },
  messages: [
	{
	  status: "SUCCESS",
	  error: {
		code: "code",
		param: "param",
		description: "description"
	  },
	  messageId: "04eda20a-e05a-4a05-8b4c-696a9f2af6ac",
	  cost: {
	    amount: 1
	  }
	}
  ]
}`,
      activeSection: '',
    }
  },
  computed: {
    codemirrorInstance() {
      return this.$refs.codeMirrorComponent.codemirror
    },
    editorOptions() {
      return {
        tabSize: 2,
        styleActiveLine: true,
        lineNumbers: true,
        lineWrapping: true,
        line: true,
        height: 'auto',
        mode: 'javascript',
        theme: 'eclipse',
        autofocus: true,
        fontSize: 12,
      }
    },
  },
  methods: {
    callScrollClick(el) {
      this.activeSection = el
      this.$refs.docContentRef.scrollClick(el)
    },
    handleSectionChange(section) {
      this.activeSection = section
    },
  },
}
</script>

<style lang="scss" scoped>
.card-body .CodeMirror {
  height: auto;
}

.highlight__text {
  h4 {
    color: #8a2100;
  }

  padding: 2%;
  background: #fff7f5;
  border-left: 3px solid var(--primary);
}
</style>

<style lang="scss" scoped>
.card {
  padding: 2% 1.5%;

  p {
    line-height: 2rem;
  }

  .table {
    thead {
      background: var(--gray-200);
    }

    td {
      border: 1px solid var(--gray-300);
    }
  }
}

.list-group-item {
  border-color: transparent;
}

.vue-codemirror {
  font-size: 12px;
}

.card-header {
  border: none;
}

.pageHeaderDocumentation {
  background-color: #19233f;
  width: 100vw;
  margin-left: -15px;
  padding: 50px 150px;
  height: 240px;
}

.pageHeaderDocumentation h1 {
  color: #fff;
  font-size: 30px;

  margin-top: 20px;
}

.pageHeaderDocumentationSubtitle {
  color: #d8d8d8;
  font-size: 20px;
  display: block;
}

.leftOptionDocumentation {
  background-color: #fff;
  margin-bottom: 30px;
  height: 100%;
  position: relative;
  padding: 64px 0 64px 0;
}

.leftOptionList {
  position: sticky;
  top: 64px;
}

.listTitle {
  font-weight: bold;
  padding-top: 10px;
  padding-bottom: 10px;
}

.listItems {
  list-style-type: square;
  cursor: pointer;
}

.selectedItem {
  color: var(--primary);
  font-weight: bold;
}
</style>
